import dynamic from 'next/dynamic';
import styled from 'styled-components';
import { t } from 'localization/utils/t';
import { useState } from 'react';

import { IExternalPicture } from 'shared/types/ExternalPicture';
import { Image } from 'shared/components/Image';
import { IRobotAsset } from 'shared/types/RobotAsset';
import { variableFont } from 'styles/theme';

const ExpandedViewMobile = dynamic(
  () => import('productTemplate/components/imageGallery/ExpandedViewMobile'),
  { ssr: false },
);

interface IRobotsGalleryMobile {
  robotAssets: IRobotAsset[];
  productTemplateImages: IExternalPicture[] | { mainPictureUrl: string }[];
  name: string;
}

const TP = 'productTemplate.components.robotGallery.Model';

export const RobotsGalleryMobile = ({
  robotAssets,
  productTemplateImages,
  name,
}: IRobotsGalleryMobile) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [clickTargetIdx, setClickTargetIdx] = useState<number>(0);

  const handleOnClick = (url) => {
    setIsExpanded(true);
    const indexOfRobot = productTemplateImages?.findIndex((image) => image?.mainPictureUrl === url);

    if (indexOfRobot >= 0) {
      setClickTargetIdx(indexOfRobot);
    }
  };

  const handleOnClose = () => {
    setIsExpanded(false);
  };

  return (
    <RobotsGalleryMobile.Wrapper data-qa="robots_gallery">
      <h2 className="header" data-qa="robots_gallery_header">
        {t(`${TP}.model`, 'Model')}
      </h2>
      <div className="robotsGallery" data-qa="robots_gallery_images">
        {robotAssets?.map((robot) => (
          <Image
            data-qa="robot_image"
            key={robot.url}
            src={robot.url}
            sizes="126px"
            alt={t(`${TP}.robotImageAlt`, 'Model wearing {name}', {
              name,
            })}
            crop
            onClick={() => handleOnClick(robot.url)}
          />
        ))}
      </div>
      {isExpanded && (
        <ExpandedViewMobile
          clickTargetIdx={clickTargetIdx}
          itemList={productTemplateImages}
          name={name}
          shouldCropImage
          onClose={handleOnClose}
        />
      )}
    </RobotsGalleryMobile.Wrapper>
  );
};

RobotsGalleryMobile.Wrapper = styled.div`
  margin: 60px 16px;

  .header {
    ${variableFont({ size: '11.5px', height: '14px', fontWeight: '400' })};
  }

  .robotsGallery {
    margin-top: 20px;
    display: flex;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 16px;

    img {
      cursor: pointer;
    }
  }
`;
